import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { FeaturePartnerHomepageComponent } from '@fitscovery/partner-web/partner-homepage';

const routes: Routes = [
	{
		path: '',
		component: FeaturePartnerHomepageComponent
	},
	{
		path: 'events',
		loadChildren: () => import('@fitscovery/partner-web/schedules/feature-shell').then(m => m.PartnerWebSchedulesFeatureShellModule)
	},
	{
		path: 'workouts',
		loadChildren: () => import('./workouts/workout.module').then(m => m.WorkoutModule)
	},
	{
		path: 'community',
		loadChildren: () => import('@fitscovery/partner-web/community/user-posts-ranking').then(m => m.PartnerWebCommunityFeatureUserPostsRankingModule)
	},
	{
		path: 'payment/membership',
		loadChildren: () => import('./payments/payment.module').then(m => m.PaymentModule)
	},
	{
		path: 'auth/authenticate',
		loadChildren: () => import('@fitscovery/redirect-authenticate/authenticate').then(m => m.RedirectAuthenticateModule)
	},
	{
		path: 'memberships',
		loadChildren: () => import('@fitscovery/partner-web/memberships/feature-shell').then(m => m.PartnerWebMembershipsFeatureShellModule)
	},
	{
		path: 'payments',
		loadChildren: () => import('./payments/payment.module').then(m => m.PaymentModule)
	},
  {
    path: '**',
    redirectTo: '',
  }
];

const routingConfiguration: ExtraOptions = {
	paramsInheritanceStrategy: 'always',
	// Flicker fix: https://github.com/angular/angular/issues/15716#issuecomment-291025332
	initialNavigation: 'enabled',
	scrollPositionRestoration: 'enabled'
};

@NgModule({
	imports: [ RouterModule.forRoot(routes, routingConfiguration) ],
	exports: [ RouterModule ]
})

export class AppRoutingModule { }
